import * as Sentry from "@sentry/react";
import * as React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";
import { UnleashClient } from "unleash-proxy-client";

import { PWA_ENV, SENTRY_SAMPLES_RATE } from "./utils/env";

// Initialised here (imported first in main.tsx) so Sentry.init runs before
// ./router wraps createBrowserRouter — required for navigation transactions.
Sentry.init({
  dsn: "https://ce59722f92ae462b69fd71101e539389@o327446.ingest.sentry.io/4506717185703936",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    }),
    Sentry.unleashIntegration({ featureFlagClientClass: UnleashClient })
  ],
  // Performance Monitoring
  tracesSampleRate: SENTRY_SAMPLES_RATE,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/(?:staging\.)?api\.kanpla\.dk\/api$/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Forward logger.ts logs to Sentry Logs
  enableLogs: true,
  enhanceFetchErrorMessages: "always",
  enabled: import.meta.env.PROD && PWA_ENV !== "development",
  environment: PWA_ENV
});
